import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";

import {Link} from 'react-router-dom';
import {loadGeneralEnum} from '../actions/enums';
import {countTransactions, loadTransactions, massUpdateTransactions} from '../actions/transactions';
import {createInvoiceFromTrn} from '../actions/invoices';
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import Transactions from '../components/transaction/Transactions';
import {Acl, breadcrumbs} from "../utils";

class TransactionsPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleCreateInvoiceFromTrn = this.handleCreateInvoiceFromTrn.bind(this);
		this.handleMassUpdateTransactions = this.handleMassUpdateTransactions.bind(this);
	}

	componentDidMount() {
		this.props.loadGeneralEnum('partyAccounts', {})
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadTransactions(filter);
		this.props.countTransactions(filter);
	}

	handleCreateInvoiceFromTrn(trnId) {
		return this.props.createInvoiceFromTrn(trnId)
	}

	handleMassUpdateTransactions(payload) {
		return this.props.massUpdateTransactions(payload)
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'Transakce'}])}
					</Col>
					<Col xs={4}>
						{Acl.isAllowed(session, Acl.transaction.CREATE) &&
						<Link to={{pathname: "/transactions/new"}} className="btn btn-success pull-right"><span className="fa fa-plus"/> Nová</Link>}
					</Col>
				</Row>
				<Transactions {...page} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onCreateInvoiceFromTrn={this.handleCreateInvoiceFromTrn}
					onMassUpdateTransaction={this.handleMassUpdateTransactions}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>
			</div>
		)
	}
}

TransactionsPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadTransactions: PropTypes.func.isRequired,
	countTransactions: PropTypes.func.isRequired,
	createInvoiceFromTrn: PropTypes.func.isRequired,
	massUpdateTransactions: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {transactions},
		enums,
		session
	} = state;

	const page = transactions[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadTransactions,
	countTransactions,
	createInvoiceFromTrn,
	massUpdateTransactions,
	showMessage,
	resetPage,
	showModal
})(TransactionsPage)
